import axios from '@/libs/api.request';

//获取苗场的黑名单用户列表
export const getSeedFarmBlackUserList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmBlackUserList',
        data: data,
        method: 'post'
    });
};
//没有权限的苗场的黑名单用户列表
export const getSeedFarmBlackUserWithoutRoleList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmBlackUserWithoutRoleList',
        data: data,
        method: 'post'
    });
};
//获取外部内部会员列表
export const getUserList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getUserList',
        data: data,
        method: 'post'
    });
};

//保存苗场黑名单
export const saveSeedFarmBlackUser = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSaveSeedFarmBlackUser',
        data: data,
        method: 'post'
    });
};

//保存苗场黑名单
export const delSeedFarmBlackUser = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/delSeedFarmBlackUser',
        data: data,
        method: 'post'
    });
};
